module.exports = "https://static.im-cdn.com/mjc/storefront/Coral/static/media/Minus.499b8c98.svg";